/**
 * variant-smart-select.js
 * ------------------------------------------------------------
 * Tabla: Talla (orden fijo) | Inventario | Entrega inmediata |
 * Sobre pedido. Muestra tambien el precio de cada talla debajo
 * del nombre de la talla (para colores nativos Y externos), y una
 * nota de tiempo de entrega para piezas sobre pedido.
 *
 * IMPORTANTE: la tabla SOLO se reconstruye por completo (innerHTML)
 * cuando cambia el COLOR (los datos de fondo son distintos: otras
 * tallas, otros precios, otro inventario). Cuando solo cambia la
 * TALLA enfocada/clickeada dentro del MISMO color, se actualiza
 * unicamente el precio de la insignia y el resaltado de fila --
 * SIN tocar el HTML de la tabla -- para no borrar las cantidades
 * que el cliente ya escribio en otras filas (puede llenar varias
 * tallas y luego dar "Agregar al carrito" una sola vez).
 *
 * Tambien actualiza el precio grande de la insignia de color
 * (.color-price-badge__price, ver product-variant-picker.liquid)
 * cada vez que cambia el color o la talla seleccionada -- TANTO en
 * colores nativos (via el picker nativo oculto) COMO en colores
 * externos (leyendo directo data-external-variants, ya que ahi no
 * hay picker nativo de Talla que dispare un 'change').
 *
 * Al hacer clic en la casilla de cantidad de una fila se actualiza
 * el precio de arriba. Se usa el evento 'click' (no solo 'focusin')
 * porque en clics reales del mouse 'focusin' no siempre llega a
 * dispararse de forma confiable en todos los navegadores/
 * dispositivos -- 'click' es mas universal (funciona igual con
 * mouse y con touch). Se deja tambien 'focusin' para navegacion por
 * teclado (tab). Al entrar a una casilla se selecciona todo su
 * contenido (input.select()) para que el cliente pueda escribir el
 * numero directo sin que se mezcle con el "0" que ya estaba (evita
 * "03" o "30" en vez de "3").
 *
 * COLORES EXTERNOS ("Colores Adicionales"): algunos colores viven
 * en un producto auxiliar aparte (para no romper el limite de 250
 * variantes de Shopify en este producto). Cuando el cliente elige
 * uno de esos colores (evento 'family:color-select' con
 * detail.external = true, disparado por custom-color-swatches.js):
 * - la tabla se reconstruye leyendo data-external-variants en vez
 *   de data-all-variants
 * - la imagen principal se reemplaza por una superposicion simple
 *   SOLO sobre el visor principal (slider-component dentro de
 *   media-gallery), sin cubrir la tira de miniaturas de abajo, para
 *   que la imagen quede en la misma posicion/tamano que siempre.
 *   Es una sola foto de frente, no la galeria completa
 *   frente/espalda/costado.
 * - "Agregar al carrito" funciona sin cambios: bulk-add-to-cart.js
 *   ya lee el data-variant-id de cada fila y lo manda a
 *   /cart/add.js, sin importar de que producto sea esa variante
 *
 * NOTA: variant.price en Liquid viene en CENTAVOS (igual que el
 * filtro `money` de Shopify espera), por eso formatMoney divide
 * entre 100 antes de mostrarlo. No se muestra "MXN" en la tabla (a
 * peticion del usuario, solo el simbolo $), pero SI se muestra en
 * la insignia de precio grande arriba de los swatches.
 * ------------------------------------------------------------
 */
(function () {
  if (window.__variantSmartSelectInit) return;
  window.__variantSmartSelectInit = true;

  var TALLA_ORDER = ['XXS', 'XS', 'S', 'CH', 'M', 'L', 'G', 'XL', '2XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];

  function tallaSortIndex(talla) {
    var idx = TALLA_ORDER.indexOf((talla || '').toUpperCase());
    return idx === -1 ? 999 : idx;
  }

  function getAllVariants(variantSelects) {
    var script = variantSelects.querySelector('script[data-all-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getExternalVariants(variantSelects) {
    var script = variantSelects.querySelector('script[data-external-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(amountInCents) {
    var num = parseFloat(amountInCents);
    if (isNaN(num)) return '';
    return '$ ' + (num / 100).toFixed(2);
  }

  function formatMoneyWithCurrency(amountInCents) {
    var num = parseFloat(amountInCents);
    if (isNaN(num)) return '';
    return '$ ' + (num / 100).toFixed(2) + ' MXN';
  }

  function updateColorPriceBadge(amountInCents) {
    var el = document.querySelector('[data-color-price]');
    if (!el || amountInCents == null) return;
    el.textContent = formatMoneyWithCurrency(amountInCents);
  }

  function getOptionValue(variantSelects, optionName) {
    var value = null;
    variantSelects.querySelectorAll('[data-option-name]').forEach(function (el) {
      var name = el.dataset.optionName;
      if (name !== optionName) return;
      if (el.tagName === 'SELECT') {
        value = el.value;
      } else if (el.type === 'radio' && el.checked) {
        value = el.value;
      }
    });
    return value;
  }

  function setOptionValue(variantSelects, optionName, newValue) {
    var escaped = window.CSS && CSS.escape ? CSS.escape(newValue) : newValue;
    var input = variantSelects.querySelector(
      'input[type="radio"][data-option-name="' + optionName + '"][value="' + escaped + '"]'
    );
    if (input) {
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    var option = variantSelects.querySelector(
      'select option[data-option-name="' + optionName + '"][value="' + escaped + '"]'
    );
    if (option) {
      var select = option.closest('select');
      if (select && select.value !== newValue) {
        option.selected = true;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function matchesValue(v, optionValue) {
    return v.option1 === optionValue || v.option2 === optionValue || v.option3 === optionValue;
  }
  function otherValueOf(v, optionValue) {
    if (v.option1 === optionValue) return v.option2 || v.option3;
    if (v.option2 === optionValue) return v.option1 || v.option3;
    return v.option1 || v.option2;
  }

  function statusHtml(variant) {
    var managed = variant.inventory_management === 'shopify';
    var qty = Math.max(variant.inventory_quantity || 0, 0);
    if (managed) {
      if (qty > 0) {
        return '<span class="vit-status-ok">' + qty + '</span>';
      }
      return '<span class="vit-status-nowrap"><span class="vit-status-agotado">Agotado</span><span class="vit-sep"> &mdash; </span><span class="vit-status-ok">Bajo Pedido</span></span>';
    }
    return '<span class="vit-status-ok">Sin control de inventario</span>';
  }

  var BACKORDER_NOTE_HTML =
    '<p class="vit-backorder-note">La columna "Sobre pedido" se solicita a nuestro proveedor y requiere un ' +
    'm\u00ednimo de 20 piezas para poder realizarse, pudiendo combinar distintas tallas y colores.</p>' +
    '<p class="vit-delivery-note">Las playeras solicitadas por la columna "Sobre pedido" tienen un tiempo de ' +
    'entrega estimado de 3 a 4 d\u00edas h\u00e1biles, contados a partir de la confirmaci\u00f3n del pedido y de ' +
    'su pago o anticipo correspondiente.</p>';

  // ---- reconstruccion COMPLETA de la tabla (solo cuando cambia el color) ----

  function renderInventoryTable(variantSelects) {
    if (variantSelects.dataset.activeColorSource === 'external') {
      renderExternalInventoryTable(variantSelects);
      return;
    }

    var section = variantSelects.closest('product-info') || document;
    var table = section.querySelector('[data-variant-inventory-table]');
    if (!table) return;

    var variants = getAllVariants(variantSelects);
    if (!variants || !variants.length) {
      table.innerHTML = '';
      return;
    }

    var color = getOptionValue(variantSelects, 'Color');
    var rows = variants.filter(function (v) {
      return color ? matchesValue(v, color) : true;
    });
    if (!rows.length) rows = variants;

    rows = rows.slice().sort(function (a, b) {
      var ta = otherValueOf(a, color) || a.title;
      var tb = otherValueOf(b, color) || b.title;
      return tallaSortIndex(ta) - tallaSortIndex(tb);
    });

    var currentTalla = getOptionValue(variantSelects, 'Talla');

    var currentVariant = rows.find(function (v) {
      var t = otherValueOf(v, color) || v.title;
      return t === currentTalla;
    });
    updateColorPriceBadge(currentVariant ? currentVariant.price : rows[0] ? rows[0].price : null);

    var html = '<p class="vit-heading">Inventario disponible</p>';
    html +=
      '<div class="vit-wrap"><table><thead><tr>' +
      '<th class="vit-col-talla">Talla</th>' +
      '<th class="vit-col-inv">Inventario</th>' +
      '<th class="vit-col-cant"><span class="vit-th-stack">Entrega<br>inmediata</span></th>' +
      '<th class="vit-col-cant">Sobre pedido</th>' +
      '</tr></thead><tbody>';

    rows.forEach(function (v) {
      var talla = otherValueOf(v, color) || v.title;
      var selected = talla === currentTalla;
      var stockQty = Math.max(v.inventory_quantity || 0, 0);
      var managed = v.inventory_management === 'shopify';
      var stockMax = managed ? stockQty : 99;
      var rowClass = selected ? 'vit-row-selected' : '';
      if (stockMax <= 0) rowClass += ' vit-row-soldout';

      html += '<tr class="' + rowClass + '" data-vit-row data-talla="' + talla + '">';
      html +=
        '<td class="vit-col-talla"><span class="vit-talla-name">' + talla + '</span>' +
        '<span class="vit-talla-price">' + formatMoney(v.price) + '</span></td>';
      html += '<td class="vit-col-inv">' + statusHtml(v) + '</td>';

      html += '<td class="vit-col-cant">';
      if (stockMax > 0) {
        html +=
          '<input type="number" class="vit-qty-input" min="0" max="' + stockMax + '" step="1" value="0"' +
          ' data-vit-qty-input data-variant-id="' + v.id + '" data-talla="' + talla + '" data-max-qty="' + stockMax + '"' +
          ' aria-label="Entrega inmediata para talla ' + talla + '">';
      } else {
        html += '<span class="vit-status-agotado">&mdash;</span>';
      }
      html += '</td>';

      html +=
        '<td class="vit-col-cant">' +
        '<input type="number" class="vit-qty-input" min="0" max="500" step="1" value="0"' +
        ' data-vit-order-input data-variant-id="' + v.id + '" data-talla="' + talla + '" data-max-qty="500"' +
        ' aria-label="Sobre pedido para talla ' + talla + '">' +
        '</td>';

      html += '</tr>';
    });
    html += '</tbody></table></div>';
    html += BACKORDER_NOTE_HTML;
    table.innerHTML = html;
  }

  function renderExternalInventoryTable(variantSelects) {
    var section = variantSelects.closest('product-info') || document;
    var table = section.querySelector('[data-variant-inventory-table]');
    if (!table) return;

    var externalVariants = getExternalVariants(variantSelects);
    if (!externalVariants || !externalVariants.length) {
      table.innerHTML = '';
      return;
    }

    var color = variantSelects.dataset.activeExternalColor;
    var rows = externalVariants.filter(function (v) {
      return v.option1 === color;
    });
    if (!rows.length) return;

    rows = rows.slice().sort(function (a, b) {
      return tallaSortIndex(a.option2) - tallaSortIndex(b.option2);
    });

    var currentTalla = variantSelects.dataset.activeExternalTalla;
    var currentVariant = rows.find(function (v) {
      return v.option2 === currentTalla;
    });
    updateColorPriceBadge(currentVariant ? currentVariant.price : rows[0].price);

    var html = '<p class="vit-heading">Inventario disponible</p>';
    html +=
      '<div class="vit-wrap"><table><thead><tr>' +
      '<th class="vit-col-talla">Talla</th>' +
      '<th class="vit-col-inv">Inventario</th>' +
      '<th class="vit-col-cant"><span class="vit-th-stack">Entrega<br>inmediata</span></th>' +
      '<th class="vit-col-cant">Sobre pedido</th>' +
      '</tr></thead><tbody>';

    rows.forEach(function (v) {
      var talla = v.option2;
      var stockQty = Math.max(v.inventory_quantity || 0, 0);
      var managed = v.inventory_management === 'shopify';
      var stockMax = managed ? stockQty : 99;
      var rowClass = stockMax <= 0 ? 'vit-row-soldout' : '';

      html += '<tr class="' + rowClass + '" data-vit-row data-talla="' + talla + '">';
      html +=
        '<td class="vit-col-talla"><span class="vit-talla-name">' + talla + '</span>' +
        '<span class="vit-talla-price">' + formatMoney(v.price) + '</span></td>';
      html += '<td class="vit-col-inv">' + statusHtml(v) + '</td>';

      html += '<td class="vit-col-cant">';
      if (stockMax > 0) {
        html +=
          '<input type="number" class="vit-qty-input" min="0" max="' + stockMax + '" step="1" value="0"' +
          ' data-vit-qty-input data-variant-id="' + v.id + '" data-talla="' + talla + '" data-max-qty="' + stockMax + '"' +
          ' aria-label="Entrega inmediata para talla ' + talla + '">';
      } else {
        html += '<span class="vit-status-agotado">&mdash;</span>';
      }
      html += '</td>';

      html +=
        '<td class="vit-col-cant">' +
        '<input type="number" class="vit-qty-input" min="0" max="500" step="1" value="0"' +
        ' data-vit-order-input data-variant-id="' + v.id + '" data-talla="' + talla + '" data-max-qty="500"' +
        ' aria-label="Sobre pedido para talla ' + talla + '">' +
        '</td>';

      html += '</tr>';
    });
    html += '</tbody></table></div>';
    html += BACKORDER_NOTE_HTML;
    table.innerHTML = html;
  }

  // ---- actualizacion LIGERA (solo cambia la talla dentro del mismo color) ----
  // No toca el HTML de la tabla ni las cantidades ya escritas: solo el precio
  // de la insignia y que fila se ve resaltada.

  function updatePriceAndHighlightNative(variantSelects) {
    var section = variantSelects.closest('product-info') || document;
    var table = section.querySelector('[data-variant-inventory-table]');
    if (!table) return;

    var variants = getAllVariants(variantSelects);
    if (!variants || !variants.length) return;

    var color = getOptionValue(variantSelects, 'Color');
    var currentTalla = getOptionValue(variantSelects, 'Talla');

    var currentVariant = variants.find(function (v) {
      return matchesValue(v, color) && otherValueOf(v, color) === currentTalla;
    });
    updateColorPriceBadge(currentVariant ? currentVariant.price : null);

    table.querySelectorAll('[data-vit-row]').forEach(function (row) {
      row.classList.toggle('vit-row-selected', row.dataset.talla === currentTalla);
    });
  }

  function updatePriceAndHighlightExternal(variantSelects) {
    var externalVariants = getExternalVariants(variantSelects);
    if (!externalVariants || !externalVariants.length) return;

    var color = variantSelects.dataset.activeExternalColor;
    var talla = variantSelects.dataset.activeExternalTalla;

    var currentVariant = externalVariants.find(function (v) {
      return v.option1 === color && v.option2 === talla;
    });
    updateColorPriceBadge(currentVariant ? currentVariant.price : null);
  }

  function getMediaViewer() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return null;
    return gallery.querySelector('slider-component');
  }

  function getOrCreateExternalOverlay() {
    var viewer = getMediaViewer();
    if (!viewer) return null;
    var overlay = viewer.querySelector('[data-external-color-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.setAttribute('data-external-color-overlay', '');
      overlay.style.cssText =
        'position:absolute;inset:0;background:rgb(var(--color-background));z-index:5;display:none;';
      var img = document.createElement('img');
      img.alt = '';
      img.style.cssText = 'width:100%;height:100%;object-fit:contain;';
      overlay.appendChild(img);
      if (getComputedStyle(viewer).position === 'static') {
        viewer.style.position = 'relative';
      }
      viewer.appendChild(overlay);
    }
    return overlay;
  }

  function showExternalImage(imageUrl) {
    if (!imageUrl) return;
    var overlay = getOrCreateExternalOverlay();
    if (!overlay) return;
    var img = overlay.querySelector('img');
    if (img) img.src = imageUrl;
    overlay.style.display = 'block';
  }

  function hideExternalImage() {
    var viewer = getMediaViewer();
    if (!viewer) return;
    var overlay = viewer.querySelector('[data-external-color-overlay]');
    if (overlay) overlay.style.display = 'none';
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-vit-qty-input], [data-vit-order-input]')) return;
    var max = parseInt(input.dataset.maxQty, 10) || 0;
    var value = parseInt(input.value, 10) || 0;
    if (value < 0) value = 0;
    if (value > max) value = max;
    input.value = value;
  });

  function handleTallaFocus(event) {
    var input = event.target;
    if (!input.matches('[data-vit-qty-input], [data-vit-order-input]')) return;

    // Selecciona el contenido para que el cliente escriba directo encima
    // del "0" (evita que le quede "03" o "30" en vez de "3").
    setTimeout(function () {
      input.select();
    }, 0);

    var talla = input.dataset.talla;
    if (!talla) return;
    var productInfo = input.closest('product-info');
    if (!productInfo) return;
    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;

    if (variantSelects.dataset.activeColorSource === 'external') {
      if (variantSelects.dataset.activeExternalTalla === talla) return;
      variantSelects.dataset.activeExternalTalla = talla;
      updatePriceAndHighlightExternal(variantSelects);
      return;
    }

    var currentTalla = getOptionValue(variantSelects, 'Talla');
    if (currentTalla === talla) return;
    setOptionValue(variantSelects, 'Talla', talla);
  }

  // 'click' es el evento principal: funciona de forma confiable con mouse
  // y con touch en cualquier dispositivo. 'focusin' se deja como respaldo
  // para quien navega con teclado (tab) sin hacer clic.
  document.addEventListener('click', handleTallaFocus, true);
  document.addEventListener('focusin', handleTallaFocus, true);

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.dataset || !input.dataset.optionName) return;
      if (input.type !== 'radio' && input.tagName !== 'SELECT') return;

      var optionName = input.dataset.optionName;
      var variantSelects = input.closest('variant-selects');
      if (!variantSelects) return;

      if (optionName.toLowerCase() === 'color') {
        var variants = getAllVariants(variantSelects);
        if (variants && variants.length) {
          var newColor = input.value;
          var currentTalla = getOptionValue(variantSelects, 'Talla');

          var match = variants.find(function (v) {
            return matchesValue(v, newColor) && v.available && otherValueOf(v, newColor) === currentTalla;
          });
          if (!match) {
            match = variants.find(function (v) {
              return matchesValue(v, newColor) && v.available;
            });
          }
          if (match) {
            var desiredTalla = otherValueOf(match, newColor);
            if (desiredTalla && desiredTalla !== currentTalla) {
              setOptionValue(variantSelects, 'Talla', desiredTalla);
            }
          }
        }
        // Cambio de COLOR: los datos de fondo son distintos, hay que
        // reconstruir toda la tabla.
        renderInventoryTable(variantSelects);
      } else if (optionName.toLowerCase() === 'talla') {
        // Cambio de TALLA dentro del mismo color: solo precio + resaltado,
        // sin tocar las cantidades que el cliente ya escribio.
        updatePriceAndHighlightNative(variantSelects);
      } else {
        renderInventoryTable(variantSelects);
      }
    },
    true
  );

  document.addEventListener('family:color-select', function (event) {
    var detail = event.detail || {};
    var wrapper = detail.wrapper;
    if (!wrapper) return;

    var variantSelects = wrapper.nextElementSibling;
    while (variantSelects && variantSelects.tagName !== 'VARIANT-SELECTS') {
      variantSelects = variantSelects.nextElementSibling;
    }
    if (!variantSelects) {
      variantSelects = wrapper.parentElement.querySelector('variant-selects');
    }
    if (!variantSelects) return;

    if (detail.external) {
      variantSelects.dataset.activeColorSource = 'external';
      variantSelects.dataset.activeExternalColor = detail.color;
      delete variantSelects.dataset.activeExternalTalla;

      var externalVariants = getExternalVariants(variantSelects);
      var firstMatch =
        externalVariants &&
        externalVariants.find(function (v) {
          return v.option1 === detail.color;
        });
      if (firstMatch && firstMatch.image) {
        showExternalImage(firstMatch.image);
      }

      // Cambio de COLOR externo: reconstruir toda la tabla (datos distintos).
      renderInventoryTable(variantSelects);
    } else {
      delete variantSelects.dataset.activeColorSource;
      delete variantSelects.dataset.activeExternalColor;
      delete variantSelects.dataset.activeExternalTalla;
      hideExternalImage();
      // El renderInventoryTable nativo se dispara solo, con el evento
      // 'change' que custom-color-swatches.js manda al radio oculto.
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('variant-selects').forEach(renderInventoryTable);
  });
  if (document.readyState !== 'loading') {
    document.querySelectorAll('variant-selects').forEach(renderInventoryTable);
  }
})();
